import React from 'react';
import Reflux from 'reflux';
import FormItemContainer from './FormItemContainer';
import FormItemConst from './FormItemConst';
import FormItemUtil from '../utils/FormItemUtil';
import ResizeActions from '../actions/ResizeActions';
require('../styles/FormItemDividedBoxStyle.css');

class FormItemDividedBox extends FormItemContainer
{

	splitterStates = 
	{
		sliderMoving:false,
		splitterIndex:0
	}

	constructor(props) {
		super(props);
		if(this.state)
			this.state = Object.assign({},this.state);
		else  
  			this.state = this.getInitialState();
  	}  	

	   

	getInitialState()
	{
		console.log(this.props.xml);
		let parent = this.props.xml;
		let children = parent.FormItem;
		let result = {childrengrow:[]};
		for(var i in children)
		{
			result.childrengrow.push(parseInt(i));
		}
		return result;
	}

	mousePosition(ev) 
	{        
		if (!ev) ev = window.event;        
		if (ev.pageX || ev.pageY) 
		{          
			return { x: ev.pageX, y: ev.pageY };        
		}        
		return {x: ev.clientX + document.documentElement.scrollLeft - document.body.clientLeft,
			y: ev.clientY + document.documentElement.scrollTop - document.body.clientTop};      
	}

	//获取一个DIV的绝对坐标的功能函数,即使是非绝对定位,一样能获取到      
	getElCoordinate(dom) {        
		var t = dom.offsetTop;        
		var l = dom.offsetLeft;        
		dom = dom.offsetParent;        
		while (dom) {          
			t += dom.offsetTop;          
			l += dom.offsetLeft;          
			dom = dom.offsetParent;        
		};        
		return { top: t, left: l };      
	};

	//分隔条幽灵左右拖动(mousemove)      
	sliderGhostMoving(e) {   
		let layout = this.props.xml.Properties.Layout.Value;
		if(layout == 'horizontal')
		{
			let _left = this.mousePosition(e).x - 2;//height:$(e.target).height()+'px'
			$(this.refs.splitterproxy).css({ left: _left, display:"block",height:'100%'});      			
		}
		else
		{
			let _top = this.mousePosition(e).y - 2;
			$(this.refs.splitterproxy).css({ top: _top, display:"block",width:'100%'});      			
		}     
		
	}; 

	//完成分隔条左右拖动(mouseup)      
	sliderHorizontalMove(e) {        
		/*var lWidth = getElCoordinate($(this.refs.splitterproxy)[0]).left - 2;        
		var rWidth = $(window).width() - lWidth - 6;        
		$("#divLeft").css("width", lWidth + "px");        
		$("#divRight").css("width", rWidth + "px");*/      
		if(!this.splitterStates.splitterIndex)
		{
			$(this.refs.splitterproxy).css("display", "none");
			return;
		}
		let layout = this.props.xml.Properties.Layout.Value;
		var proxyPosition = this.getElCoordinate($(this.refs.splitterproxy)[0]);
		if(this.startProxyPosition)
		{
			if(layout == "horizontal")
			{
				if(Math.abs(proxyPosition.left-this.startProxyPosition.left)<2)
				{
					$(this.refs.splitterproxy).css("display", "none");
					return;
				}
			}
			else if(layout == "vertical")
			{
				if(Math.abs(proxyPosition.top-this.startProxyPosition.top)<2)
				{
					$(this.refs.splitterproxy).css("display", "none");
					return;
				}
			}
		}
		
		var _index = parseInt(this.splitterStates.splitterIndex);
		
		var nowSplitter = $(this.refs['splitter'+_index]);
		var splitterPosition = this.getElCoordinate(nowSplitter[0]);
		
		if(layout == "horizontal")
		{
			//当前分隔条左边还有分隔条
			if(_index>0 && this.refs.hasOwnProperty('splitter'+(_index-1)))
			{
				let leftSplitterPosition = this.getElCoordinate($(this.refs['splitter'+(_index-1)])[0]);
				if(proxyPosition.left<leftSplitterPosition.left)
					proxyPosition.left = leftSplitterPosition.left;
			}
			//当前分隔条右边还有分隔条
			if(this.refs.hasOwnProperty('splitter'+(_index+1)))
			{
				let leftSplitterPosition = this.getElCoordinate($(this.refs['splitter'+(_index+1)])[0]);
				if(proxyPosition.left>leftSplitterPosition.left)
					proxyPosition.left = leftSplitterPosition.left;
			}
			
			var differ = proxyPosition.left - splitterPosition.left;
			var nowSplitterChildIndex = _index*2+1;
			var leftCon = $(this.containerComponent).children()[nowSplitterChildIndex-1];
			var rightCon = $(this.containerComponent).children()[nowSplitterChildIndex+1];

			if($(leftCon).is(":hidden") || $(rightCon).is(":hidden"))
			{
				$(this.refs.splitterproxy).css("display", "none");
				return;
			}

			var leftConFlexGrow = $(leftCon).css("flex-grow");
			if(leftConFlexGrow == "0" || !leftConFlexGrow)
				$(leftCon).width($(leftCon).outerWidth()+differ);
			var rightConFlexGrow = $(rightCon).css("flex-grow");
			if(rightConFlexGrow == "0" || !rightConFlexGrow)
				$(rightCon).width($(rightCon).outerWidth()-differ);
		}
		else
		{
			//当前分隔条上边还有分隔条
			if(_index>0 && this.refs.hasOwnProperty('splitter'+(_index-1)))
			{
				let leftSplitterPosition = this.getElCoordinate($(this.refs['splitter'+(_index-1)])[0]);
				if(proxyPosition.top<leftSplitterPosition.top)
					proxyPosition.top = leftSplitterPosition.top;
			}
			//当前分隔条下边还有分隔条
			if(this.refs.hasOwnProperty('splitter'+(_index+1)))
			{
				let leftSplitterPosition = this.getElCoordinate($(this.refs['splitter'+(_index+1)])[0]);
				if(proxyPosition.top>leftSplitterPosition.top)
					proxyPosition.top = leftSplitterPosition.top;
			}
			
			var differ = proxyPosition.top - splitterPosition.top;
			
			var nowSplitterChildIndex = _index*2+1;
			var upCon = $(this.containerComponent).children()[nowSplitterChildIndex-1];
			var downCon = $(this.containerComponent).children()[nowSplitterChildIndex+1];

			if($(upCon).is(":hidden") || $(downCon).is(":hidden"))
			{
				$(this.refs.splitterproxy).css("display", "none");
				return;
			}
			var upConFlexGrow = $(upCon).css("flex-grow");
			//if(upConFlexGrow == "0" || !upConFlexGrow)
			//{
				if(upConFlexGrow!="0")$(upCon).css("flex-grow","0");
				$(upCon).css('height',upCon.offsetHeight+differ+'px');
				let upConId = $(upCon).attr("data-xmlid");
				
				var upParentControl = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,upConId));
				if(upParentControl.xml.type == "DataGrid")
				{
					ResizeActions.verticalSplitterResize(upConId,differ);
				}
				else if(upParentControl.xml.type == "Tab")
				{
					ResizeActions.verticalSplitterResize(upConId,differ);
				}
				this.dispatchVerticalResize(upParentControl.xml,differ);
			//}
			
			/*else if(upConFlexGrow == "100")
			{
				var upParentControl = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,$(upCon).attr("id")));
				this.dispatchVerticalResize(upParentControl.xml,0);
			}*/
			var downConFlexGrow = $(downCon).css("flex-grow");
			//if(downConFlexGrow == "0" || !downConFlexGrow)
			//{
				if(downConFlexGrow!="0")$(downCon).css("flex-grow","0");
				$(downCon).css('height',(downCon.offsetHeight-differ) + 'px');
				let downConId = $(downCon).attr("data-xmlid");
				var downParentControl = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,downConId));
				if(downParentControl.xml.type == "DataGrid")
				{
					ResizeActions.verticalSplitterResize(downConId,0-differ);
				}
				else if(downParentControl.xml.type == "Tab")
				{
					ResizeActions.verticalSplitterResize(downConId,0-differ);
				}
				this.dispatchVerticalResize(downParentControl.xml,0-differ);
			//}
			/*else if(downConFlexGrow == "100")
			{
				var downParentControl = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,$(downCon).attr("id")));
				this.dispatchVerticalResize(downParentControl.xml,0);
			}*/
		}
		

		var addon = layout=='horizontal'?(proxyPosition.left-splitterPosition.left):(proxyPosition.top-splitterPosition.top);

		var $leftcon = $(this.refs['con'+_index]);
		var $rightcon = $(this.refs['con'+(_index+1)]);
		if(layout == 'horizontal')
		{
			$leftcon.css("width",($leftcon.width()+addon)+'px');
			$rightcon.css("width",($rightcon.width()-addon)+'px');
		}
		else
		{
			$leftcon.css("height",($leftcon.height()+addon)+'px');
			$rightcon.css("height",($rightcon.height()-addon)+'px');
		}
		
		$(this.refs.splitterproxy).css("display", "none");      
	};
	
	dispatchVerticalResize(parent,addon)
	{
		let children = parent.FormItem;
		for(var i in children)
		{
			let child = children[i];
			if(child.type == "DataGrid")
			{
				ResizeActions.verticalSplitterResize(child.id,addon);
			}
			else if(child.type == "Tab")
			{
				ResizeActions.verticalSplitterResize(child.id,addon);
			}
			this.dispatchVerticalResize(child,addon);
		}
	}

	onSplitterMouseDown(e)
	{
		this.splitterStates.splitterIndex = $(e.target).attr('data-index');
		if(!this.splitterStates.splitterIndex)
			return;
		this.splitterStates.sliderMoving=true;
		
		
		this.startProxyPosition = this.getElCoordinate($(this.refs.splitterproxy)[0]);
		let layout = this.props.xml.Properties.Layout.Value;
		if(layout == "horizontal")
		{
			$(this.refs.dividedbox).css("cursor", "w-resize"); 	
		}
		else
		{
			$(this.refs.dividedbox).css("cursor", "s-resize"); 		
		}
		
	}

	onSplitterMouseMoving(e)
	{
		//alert('move1');
		if(this.splitterStates.sliderMoving)
		{
			//alert('move2');
			this.sliderGhostMoving(e); 
		}
	}

	onSplitterMouseUp(e)
	{
		if(this.splitterStates.sliderMoving)
		{            
	      	this.splitterStates.sliderMoving = false;            
	      	this.sliderHorizontalMove(e);            
	      	$(this.refs.dividedbox).css("cursor", "default");
	      	//let layout = this.props.xml.Properties.Layout.Value;
	      	//this.desDataGrid(this.props.xml,'splitterResize',layout);
        }       
	}

	/*desDataGrid(xml,type,layout)
	{
		let children = xml.FormItem;
		for(var i in children)
		{
			let child = children[i];
			if(child.type == "DataGrid")
			{
				if(type == 'splitterResize')
				{
					//alert('splitterResize');
					ResizeActions.splitterResize(child.id,layout);
				}
				else
					ResizeActions.dividedBoxDidMount(child.id,"vertical",8);
			}
			this.desDataGrid(child,type,layout);
		}        
	}*/
	componentDidMount()
	{
		/* onMouseDown={this.onSplitterMouseDown.bind(this)}
		 onMouseMove={this.onSplitterMouseMoving.bind(this)}
		 onMouseUp={this.onSplitterMouseUp.bind(this)}
		let that = this;
		$(this.refs.splitter).on("mousedown",this.onSplitterMouseDown.bind(this));          
		$(this.refs.dividedbox).on("mousemove",function(e){that.onSplitterMouseMoving.bind(that)(e)});          
		$(this.refs.dividedbox).on("mouseup", function (e){that.onSplitterMouseUp.bind(that)(e)});*/
		super.componentDidMount();
		let layout = this.props.xml.Properties.Layout.Value;
		if(layout == "vertical")
		{
			//this.desDataGrid(this.props.xml,'didMount',layout);
			/*let children = this.props.xml.FormItem;
			for(var i in children)
			{
				let child = children[i];
				
				if(child.type == "DataGrid")
				{
					
					ResizeActions.dividedBoxDidMount(child.id,"vertical",-8);
				}
			}*/
		}
	}

	getSplitChildren()
	{
		let parent = this.props.xml;
		let children = parent.FormItem;
		let layout = this.props.xml.Properties.Layout.Value;
		let result = [];let num = 0;
		let divInSplitterStyle = {position:'absolute',overflow:'visible',display:'flex'};
		let splitterStyle = {alignSelf:'stretch',position:'relative'/*,flexShrink:0*/};
		let leftAStyle = {cursor:'pointer'};
		let rightAStyle = {overflow:'hidden',display:'block',cursor:'pointer'};
		if(layout == 'horizontal')
		{
			splitterStyle.width = '5px';splitterStyle.cursor = 'w-resize';
			divInSplitterStyle.marginTop = '-35px';divInSplitterStyle.left = 0;divInSplitterStyle.top = '50%';divInSplitterStyle.width = '100%';divInSplitterStyle.flexDirection = 'column';
			leftAStyle.marginTop = '-35px';leftAStyle.background = 'url(images/miniLeft.png) no-repeat 50% 50%';leftAStyle.height='35px';
			rightAStyle.height = '35px';rightAStyle.background = 'url(images/miniRight.png) no-repeat 50% 50%';
		}
		else
		{
			splitterStyle.height = '5px';splitterStyle.cursor = 's-resize';
			divInSplitterStyle.marginLeft = '-35px';divInSplitterStyle.top = 0;divInSplitterStyle.left = '50%';divInSplitterStyle.height='100%';divInSplitterStyle.flexDirection = 'row';
			leftAStyle.marginLeft = '-35px';leftAStyle.background = 'url(images/miniLeftH.png) no-repeat 50% 50%';leftAStyle.width='35px';
			rightAStyle.width = '35px';rightAStyle.background = 'url(images/miniRightH.png) no-repeat 50% 50%';
		}
			
		for(var i in children)
		{
			let child = children[i];
			let formItemChild = FormItemUtil.getFormItemInstance(this.props.menuItemId,this.props.formId,child,parent,this.props.forLookup);
			let flexDirection = layout == 'horizontal'?'row':'column';
			let conStyle = {display:'flex',flexDirection:flexDirection,alignSelf:'stretch',overflow:'auto',padding:'0px'/*,flexShrink:0*/};
			
			if(FormItemConst.isMaxControl(child,layout))
			{
				conStyle.flexGrow = 100;
			}
			else if(FormItemConst.containsMaxControl(child,layout))
			{
				conStyle.flexGrow = 100;
			}
			else
			{
				conStyle.flexGrow = 0;
			}
			//result.push(<div key={'con'+i} ref={"con"+i} style={conStyle}>{formItemChild}</div>);
			result.push(formItemChild);
			if(num<children.length-1)
			{
				let _splitterStyle = Object.assign({},splitterStyle);
				if(formItemChild.props.controlVisible == false)
					_splitterStyle.display = "none";
				result.push
				(
					<div ref={"splitter"+i} data-index={i} key={'splitter'+i} style={_splitterStyle}
					     onMouseDown={this.onSplitterMouseDown.bind(this)}
						 >
						<div style={divInSplitterStyle}>
							<a title="" style={leftAStyle}  onClick={this.onSplitterLeftConClick.bind(this,i)}>
							</a>					
							<a title="" style={rightAStyle} onClick={this.onSplitterRightConClick.bind(this,i)}>
							</a>
						</div>
					</div>
				);
			}
			else
			{
				let proxyStyle = {};
				if(layout == "horizontal")proxyStyle.cursor = "w-resize;";else proxyStyle.cursor = "s-resize";
				result.push
				(
					<div key="splitterproxy" ref="splitterproxy" style={proxyStyle} className="dividedbox_splitter_proxy"></div>
				);
			}
			num++;
		}
		return result;
	}

	onSplitterLeftConClick(count,event)
	{
		var nowSplitterChildIndex = count*2+1;
		var rightCon = $(this.containerComponent).children()[nowSplitterChildIndex+1];
		
		if($(rightCon).is(":hidden"))
		{
			$(rightCon).show();
		}
		else
		{
			var leftCon = $(this.containerComponent).children()[nowSplitterChildIndex-1];

			$(leftCon).hide();
		}
	}

	onSplitterRightConClick(count,event)
	{
		var nowSplitterChildIndex = count*2+1;
		var leftCon = $(this.containerComponent).children()[nowSplitterChildIndex-1];
		if($(leftCon).is(":hidden"))
		{
			$(leftCon).show();
		}
		else
		{
			var rightCon = $(this.containerComponent).children()[nowSplitterChildIndex+1];
			$(rightCon).hide();
		}
	}

	render()
	{
		let _style = Object.assign({},this.props.customStyle);
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) _style.display="none"; else _style.visibility="hidden";
		let list = this.getSplitChildren();
		return (
			<div style={_style} ref="dividedbox" className={"FormItemDividedBox"} id={this.props.xml.name} ref={node => this.containerComponent = node}
				 onMouseMove={this.onSplitterMouseMoving.bind(this)}
		 		 onMouseUp={this.onSplitterMouseUp.bind(this)}
		 	>
				{list}
			</div>
		);
	}
};

FormItemDividedBox.defaultProps = {
};

export default FormItemDividedBox;


// WEBPACK FOOTER //
// ./src/formItem/FormItemDividedBox.js